<div *ngIf="restopop == 0">
    <div class="allergens-head">
        <div class="allergensBtn" [ngClass]="{ bgSelectClass: l1_waiting }" (click)="l1WaitingRestoList()">
            Level 1 - Waiting
        </div>

        <div class="allergensBtn dietaryBtn" [ngClass]="{ bgSelectClass: l1_approved }" (click)="l1ApprovedRestoList()">
            Level 1 - Approved
        </div>

        <div class="allergensBtn dietaryBtn" [ngClass]="{ bgSelectClass: l2 }" (click)="l2RestoList()">
            Level 2
        </div>

        <div class="allergensBtn dietaryBtn" [ngClass]="{ bgSelectClass: l3 }" (click)="l3RestoList()">
            Level 3
        </div>
    </div>

    <div *ngIf="!restofound" style="display: flex;flex-direction:column;align-items:center">
        <img src="../../../assets/img/no_task_found_illustration-v1.svg" alt="" style="width: 37vw;">
        <h1 style="margin-top: 20px;margin-right: 6vw;">No Pending Task</h1>
    </div>
    <div class="containerResto" *ngIf="restofound">
        <div class="container-head">
            <span class="noOfRestoList">{{noResto}} Restaurants</span>
            <span class="resto-input">
                <div style="padding: 2px">
                    <img src="../../../assets/images/Search.png" alt="" />
                    <input placeholder="Restaurant name or ID" [(ngModel)]="searchText" (ngModelChange)="filter()" />
                </div>
            </span>
            <!-- <div (click)="addResto()" class="addRestoBtn">
                <div>
                  <img src="../../../assets/images/Plus.png" alt="" />
                  <span>Add Restaurants</span>
                </div>
              </div> -->
        </div>
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 demo-table">
            <!-- Position Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                    SL No.
                </th>
                <td mat-cell *matCellDef="let element; let i = index" class="table-element">
                    {{ i + 1 }}
                </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                    Name
                </th>
                <td mat-cell *matCellDef="let element" class="table-element">
                    {{ element.resto_name }}
                </td>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                    Email
                </th>
                <td mat-cell *matCellDef="let element" class="table-element">
                    {{ element.email }}
                </td>
            </ng-container>

            <!-- Level Column -->
            <ng-container matColumnDef="level">
                <th mat-header-cell *matHeaderCellDef class="table-head checking">
                    Level
                </th>
                <td mat-cell *matCellDef="let element" class="table-element">
                    {{ element.level }}
                </td>
            </ng-container>

            <!-- Weight Column -->
            <ng-container matColumnDef="info">
                <th mat-header-cell *matHeaderCellDef class="table-head checking" style="text-align: center;">
                    City & Claimed Date
                </th>
                <td mat-cell *matCellDef="let element" class="table-element" style="text-align:center">
                    <div style="display: flex;align-items: center;justify-content: center;">
                        {{ element?.city }}
                         - 
                        {{ getClaimedDate(element.created_on) }}
                    </div>

                </td>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="table-head action-th checking" style="text-align: center;">
                    Action
                </th>
                <td mat-cell *matCellDef="let element" class="table-element action-element">
                    <div
                        style="display: flex;align-items: center;justify-content: center;gap: 5px;padding-right: 0;min-width: 80px;">
                        <ng-container *ngIf="element.level == 'Level 1 - Waiting';">
                            <img src="../../../assets/images/editIcon.png" alt="" class="edit-element"
                                (click)="updateRestoFunc(element)" />
                                <span style="font-size: 26px;"> | </span>
                        </ng-container>

                        <ng-container *ngIf="element.level == 'Level 1 - Waiting'">
                            <img src="../../../assets/images/deletIcon.png" alt="" (click)="openDialog(element.id)" />
                            <span style="font-size: 26px;" *ngIf="l1_approved || l2"> | </span>
                        </ng-container>
                        
                        <ng-container *ngIf="l1_approved || l2">
                            <img src="../../../assets/img/mail-all-svgrepo-com.svg" alt=""
                                style="width: 25px; cursor: pointer;" (click)="triggerEmail(element)">
                        </ng-container>
                    </div>
                </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator #paginator1 [pageSizeOptions]="[12, 20, 25]" showFirstLastButtons></mat-paginator>
    </div>

</div>
<!-- --------------------------------------------------------------------------------------------------------------- -->
<div *ngIf="restopop == 1" class="addRestoMainContainer">
    <div class="approve-mainContainer">
        <div class="approve-right-div">
            <h2 style="text-align: center; margin-top: 10px;">Foodbud data</h2>
            <div class="input-container">
                <label for="restoName">Restaurant Name<span class="starReq">*</span></label>
                <input type="text" id="restoName" name="restoName" placeholder="enter the restaurant name"
                    class="form-control" [(ngModel)]="restoName" #name="ngModel" required />
            </div>
            <div class="input-container">
                <label for="emailId">Email ID<span class="starReq">*</span></label>
                <input type="email" name="emailId" placeholder="enter the email-id" class="form-control"
                    [(ngModel)]="restoEmail" #email="ngModel" required />
            </div>
            <div class="input-container">
                <label for="restoName">Restaurant Telephone<span class="starReq">*</span></label>
                <input type="text" (keypress)="validateNum($event)" placeholder="enter restaurant telephone"
                    class="form-control" [(ngModel)]="restoPhone" name="restoTel" #restoTel="ngModel" required />
            </div>
            <div class="input-container">
                <label for="restoName">Restaurant Description<span class="starReq">*</span></label>
                <input type="text" placeholder="enter restaurant description" class="form-control"
                    [(ngModel)]="restoDescription" name="restoTel" #restoTel="ngModel" required />
            </div>
            <div class="input-container">
                <label for="emailId">Website<span class="starReq">*</span></label>
                <input type="url" name="website" placeholder="enter the website url" class="form-control"
                    [(ngModel)]="restoWebsite" #website="ngModel" required />
            </div>

            <div class="input-container">
                <label for="emailId">Avg. Rating<span class="starReq">*</span></label>
                <input type="text" name="avgRating" placeholder="enter the avg. rating" class="form-control"
                    [(ngModel)]="restoAvgRating" #website="ngModel" required />
            </div>
            <div class="input-container">
                <label for="restoName">Restaurant Address<span class="starReq">*</span></label>
                <textarea class="form-control" id="newRrestoAddress" rows="3" [(ngModel)]="restoAddress" name="restoAdd"
                    #restoAdd="ngModel" required></textarea>
            </div>
            <div class="input-container">
                <label for="">Cuisine types</label>
                <div class="cuisine-div" id="cuisine">
                    <div *ngFor="let item of allCuisine" style="display: flex; margin-bottom :15px;">
                        <input type="checkbox" name="" id="" class="largerCheckbox form-check-input "
                            [checked]="preSelectFunc('cuisine',item.id)"
                            (change)="checkChangeHandle('cuisine',item.id,$event.target)">
                        <div class="cuisine-name"> {{item.name}}</div>
                    </div>
                </div>
            </div>

            <div class="input-container">
                <label for="">Categories</label>
                <div class="cuisine-div" id="categories">
                    <div *ngFor="let item of allCaategory" style="display: flex; margin-bottom :15px;">
                        <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                            [checked]="preSelectFunc('categories',item.id)"
                            (change)="checkChangeHandle('categories',item.id,$event.target)" />
                        <div class="cuisine-name"> {{item.name}}</div>
                    </div>
                </div>
            </div>

            <div class="input-container">
                <label for="">Dietary preference</label>
                <div class="cuisine-div" id="dietPref">
                    <div *ngFor="let item of allDieatary" style="display: flex; margin-bottom :15px;">
                        <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                            [checked]="preSelectFunc('dietPref',item.id)"
                            (change)="checkChangeHandle('dietPref',item.id,$event.target)" />
                        <div class="cuisine-name"> {{item.name}}</div>
                    </div>
                </div>
            </div>

            <div class="input-container">
                <label for="">Opening and closing hours</label>
                <div class="bigScreen">
                    <div style="margin-left: 15px; display: grid;grid-template-columns: 1fr 1fr 1fr;" id="timeOld">
                        <div class="time-text">Select days</div>
                        <div class="time-text">Open timings</div>
                        <div class="time-text">Close timings</div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeOldMon" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('mondayTime',$event.target)" [(checked)]="oldmonPrecheck"
                                (change)="timeEdit('mon',$event.target)">
                            <div class="cuisine-name"> Monday </div>
                        </div>
                        <div id="mondayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldmonOpenHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldmonOpenMM" />
                            <select class="time-selectOption" [(ngModel)]="oldmonOpenMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="mondayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldmonCloseHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldmonCloseMM" />
                            <select class="time-selectOption" [(ngModel)]="oldmonCloseMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeOldTue" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('tuesdayTime',$event.target)" [checked]="oldtuePrecheck"
                                (change)="timeEdit('tue',$event.target)">
                            <div class="cuisine-name"> Tuesday </div>
                        </div>
                        <div id="tuesdayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldtueOpenHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldtueOpenMM" />
                            <select class="time-selectOption" [(ngModel)]="oldtueOpenMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="tuesdayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldtueCloseHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldtueCloseMM" />
                            <select class="time-selectOption" [(ngModel)]="oldtueCloseMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>

                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeOldWed" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('wednesTime',$event.target)" [checked]="oldwedPrecheck"
                                (change)="timeEdit('wed',$event.target)">
                            <div class="cuisine-name"> Wednesday </div>
                        </div>
                        <div id="wednesTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldwedOpenHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldwedOpenMM" />
                            <select class="time-selectOption" [(ngModel)]="oldwedOpenMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="wednesTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldwedCloseHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldwedCloseMM" />
                            <select class="time-selectOption" [(ngModel)]="oldwedCloseMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>

                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeOldThu" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('thursdayTime',$event.target)" [checked]="oldthurPrecheck"
                                (change)="timeEdit('thu',$event.target)">
                            <div class="cuisine-name"> Thursday </div>
                        </div>
                        <div id="thursdayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldthurOpenHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldthurOpenMM" />
                            <select class="time-selectOption" [(ngModel)]="oldthurOpenMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="thursdayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldthurCloseHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldthurCloseMM" />
                            <select class="time-selectOption" [(ngModel)]="oldthurCloseMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>

                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeOldFri" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('fridayTime',$event.target)" [checked]="oldfriPrecheck"
                                (change)="timeEdit('fri',$event.target)">
                            <div class="cuisine-name"> Friday </div>
                        </div>
                        <div id="fridayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldfriOpenHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldfriOpenMM" />
                            <select class="time-selectOption" [(ngModel)]="oldfriOpenMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="fridayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldfriCloseHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldfriCloseMM" />
                            <select class="time-selectOption" [(ngModel)]="oldfriCloseMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>


                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeOldSat" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('saturdayTime',$event.target)" [checked]="oldsatPrecheck"
                                (change)="timeEdit('sat',$event.target)">
                            <div class="cuisine-name"> Saturday </div>
                        </div>
                        <div id="saturdayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldsatOpenHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldsatOpenMM" />
                            <select class="time-selectOption" [(ngModel)]="oldsatOpenMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="saturdayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldsatCloseHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldsatCloseMM" />
                            <select class="time-selectOption" [(ngModel)]="oldsatCloseMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>

                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeOldSun" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('sundayTime',$event.target)" [checked]="oldsunPrecheck"
                                (change)="timeEdit('sun',$event.target)">
                            <div class="cuisine-name"> Sunday </div>
                        </div>
                        <div id="sundayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldsunOpenHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldsunOpenMM" />
                            <select class="time-selectOption" [(ngModel)]="oldsunOpenMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="sundayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="oldsunCloseHH" />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="oldsunCloseMM" />
                            <select class="time-selectOption" [(ngModel)]="oldsunCloseMead">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>

                    </div>

                </div>
            </div>

            <div class="input-container">
                <label for="">Special offers</label>
                <div class="time-text">Select days</div>
                <div style="margin-left: 15px;">
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('monOld',$event.target)" [(checked)]="offerOldMonday">
                            <div class="cuisine-name"> Monday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerOldMonday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerOldMonday"
                                [(ngModel)]="offerOldMonValue">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('tueOld',$event.target)" [(checked)]="offerOldTuesday">
                            <div class="cuisine-name"> Tuesday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerOldTuesday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerOldTuesday">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('wedOld',$event.target)" [(checked)]="offerOldWednesday">
                            <div class="cuisine-name"> Wednesday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerOldWednesday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerOldWednesday"
                                [(ngModel)]="offerOldWedValue">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('thuOld',$event.target)" [(checked)]="offerOldTurusday">
                            <div class="cuisine-name"> Thursday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerOldTurusday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerOldTurusday"
                                [(ngModel)]="offerOldThurValue">
                        </div>

                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('friOld',$event.target)" [(checked)]="offerOldFriday">
                            <div class="cuisine-name"> Friday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerOldFriday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerOldFriday"
                                [(ngModel)]="offerOldFriValue">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('satOld',$event.target)" [(checked)]="offerOldSaturday">
                            <div class="cuisine-name"> Saturday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerOldSaturday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerOldSaturday"
                                [(ngModel)]="offerOldSatValue">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('sunOld',$event.target)" [(checked)]="offerOldSunday">
                            <div class="cuisine-name"> Sunday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerOldSunday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerOldSunday"
                                [(ngModel)]="offerOldSunValue">
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-container">
                <label for="">Social Links</label>
                <div style="margin-left: 15px;">
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="socialLinkHandelFunc('instagram', $event.target)" [(checked)]="instagramCon">
                            <div class="cuisine-name" style="margin-top: 0;"> <img
                                    src="../../../assets/img/Instagram-Logo.wine.svg" alt="" srcset=""
                                    style="max-width: 65px;"> Instagram </div>
                        </div>
                        <div class="offer-sub-div" *ngIf="instagramCon">
                            <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                                [(ngModel)]="instagramVal" placeholder="Please give the link">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="socialLinkHandelFunc('facebook', $event.target)" [(checked)]="facebookCon">
                            <div class="cuisine-name" style="margin-top: 0;"> <img
                                    src="../../../assets/img/Facebook-f_Logo-Blue-Logo.wine.svg" alt="" srcset=""
                                    style="max-width: 65px;"> Facebook </div>
                        </div>
                        <div class="offer-sub-div" *ngIf="facebookCon">
                            <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                                [(ngModel)]="facebookVal" placeholder="Please give the link">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="socialLinkHandelFunc('googleMap', $event.target)" [(checked)]="googleMapCon">
                            <div class="cuisine-name" style="margin-top: 0;"> <img
                                    src="../../../assets/img/Google_Maps-Icon-Logo.wine.svg" alt="" srcset=""
                                    style="max-width: 65px;"> Google Map </div>
                        </div>
                        <div class="offer-sub-div" *ngIf="googleMapCon">
                            <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                                [(ngModel)]="googleMapVal" placeholder="Please give the link">
                        </div>
                    </div>
                </div>
            </div>
            <div class="input-container">
                <label for="restoName">Restaurant Logo (less than 500kb)</label>
                <div>
                    <span class="imgPreview"><img [src]="src" alt="" style="border-radius: 50%;" /></span>
                    <span>
                        <input type="file" accept="image/png,image/jpeg" (change)="onImageChange($event,'compareLogo')"
                            #fileInput_image hidden name="imgFile" id="compareLogo" />
                        <button class="uploadBtn" (click)="fileInput_image.click()">
                            <img src="../../../assets/images/uploadIcon.png" alt="" /><span>Upload</span>
                        </button>
                    </span>
                </div>
            </div>

            <div class="input-container">
                <label for="restoName">Featured image (less than 500kb)</label>
                <div>
                    <span class="imgPreview"><img [src]="featureSrc" alt="menu img" /></span>
                    <span>
                        <input type="file" accept="image/png,image/jpeg,"
                            (change)="onFeatureImgChange($event,'compareFeatureId')" #fileInput_feature_image hidden
                            name="imgFile" id="compareFeatureId" />
                        <button class="uploadBtn" (click)="fileInput_feature_image.click()">
                            <img src="../../../assets/images/uploadIcon.png" alt="" /><span>Upload</span>
                        </button>
                    </span>

                </div>
            </div>

        </div>
        <!-- ---------------------------------------------------------------------------------------------------------------- -->
        <!-- ---------------------------------------------------------------------------------------------------------------- -->
        <!-- ---------------------------------------------------------------------------------------------------------------- -->
        <!-- ---------------------------------------------------------------------------------------------------------------- -->
        <!-- ---------------------------------------------------------------------------------------------------------------- -->
        <!-- ---------------------------------------------------------------------------------------------------------------- -->
        <!-- ---------------------------------------------------------------------------------------------------------------- -->
        <!-- ---------------------------------------------------------------------------------------------------------------- -->
        <!-- ---------------------------------------------------------------------------------------------------------------- -->
        <div class="approve-left-div">
            <h2
                style="text-align: center; margin-top: 10px;display: flex;justify-content: center;position: relative;align-items: center;">
                <button class="copyAllBtn" (click)="copyAllToMain()">Copy All</button>
                Web page data
            </h2>
            <div class="input-container">
                <label for="restoName">Restaurant Name<span class="starReq">*</span></label>
                <div class="makeFlex">
                    <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon"
                        (click)="copyToMain('restoName')" *ngIf="restoName != restoNewName && restoNewName != ''">
                    <input type="text" id="restoName" name="restoName" class="form-control"
                        [ngClass]="{'bgChange': restoName != restoNewName}" [(ngModel)]="restoNewName" #name="ngModel"
                        required readonly />
                </div>
            </div>
            <div class="input-container">
                <label for="emailId">Email ID<span class="starReq">*</span></label>
                <div class="makeFlex">
                    <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon"
                        (click)="copyToMain('restoEmail')" *ngIf="restoEmail != restoNewEmail && restoNewEmail != ''">
                    <input type="email" name="emailId" class="form-control" [(ngModel)]="restoNewEmail" #email="ngModel"
                        required [ngClass]="{'bgChange': restoEmail != restoNewEmail}" readonly />
                </div>
            </div>
            <div class="input-container">
                <label for="restoName">Restaurant Telephone<span class="starReq">*</span></label>
                <div class="makeFlex">
                    <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon"
                        (click)="copyToMain('restoPhone')" *ngIf="restoPhone != restoNewPhone && restoNewPhone != ''">
                    <input type="text" class="form-control" [(ngModel)]="restoNewPhone" name="restoTel"
                        #restoTel="ngModel" required (keypress)="validateNum($event)"
                        [ngClass]="{'bgChange': restoPhone != restoNewPhone}" readonly />
                </div>
            </div>

            <div class="input-container">
                <label for="restoName">Restaurant Description<span class="starReq">*</span></label>
                <div class="makeFlex">
                    <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon"
                        (click)="copyToMain('restoDescription')"
                        *ngIf="restoDescription != restoNewDescription && restoNewDescription != ''">
                    <input type="text" class="form-control" [(ngModel)]="restoNewDescription" name="restoTel"
                        #restoTel="ngModel" required (keypress)="validateNum($event)"
                        [ngClass]="{'bgChange': restoDescription != restoNewDescription}" readonly />
                </div>
            </div>

            <div class="input-container">
                <label for="emailId">Website<span class="starReq">*</span></label>
                <div class="makeFlex">
                    <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon"
                        (click)="copyToMain('restoWebsite')"
                        *ngIf="restoWebsite != restoNewWebsite && restoNewWebsite != ''">
                    <input type="url" name="websiteId" class="form-control" [(ngModel)]="restoNewWebsite"
                        #website="ngModel" required [ngClass]="{'bgChange': restoWebsite != restoNewWebsite}"
                        readonly />
                </div>
            </div>

            <div class="input-container">
                <label for="emailId">Avg. Rating<span class="starReq">*</span></label>
                <div class="makeFlex">
                    <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon"
                        (click)="copyToMain('restoAvgRating')"
                        *ngIf="restoAvgRating != restoNewAvgRating && restoNewAvgRating != ''">
                    <input type="text" name="avgRating" placeholder="enter the avg. rating" class="form-control"
                        [(ngModel)]="restoNewAvgRating" #website="ngModel" required disabled="true" readonly />
                </div>
            </div>


            <div class="input-container">
                <label for="restoName">Restaurant Address<span class="starReq">*</span></label>
                <div class="makeFlex">
                    <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon"
                        (click)="copyToMain('restoAddress')"
                        *ngIf="restoAddress != restoNewAddress && restoNewAddress != ''">
                    <textarea class="form-control" id="newRrestoAddress" rows="3" [(ngModel)]="restoNewAddress"
                        name="restoAdd" #restoAdd="ngModel" [ngClass]="{'bgChange': restoAddress != restoNewAddress}"
                        readonly></textarea>
                </div>
            </div>
            <div class="input-container">
                <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon" (click)="copyToMain('cuisine')"
                    *ngIf="stringSelectedCuisine != stringSelectedNewCuisine" />
                <label for="">Cuisine types</label>
                <div class="cuisine-div" id="cuisineNew">
                    <div *ngFor="let item of allCuisine" style="display: flex; margin-bottom :15px;">
                        <input type="checkbox" name="" id="" class="largerCheckbox form-check-input "
                            [checked]="preSelectFunc('cuisineNew',item.id)" disabled="true">
                        <div class="cuisine-name"> {{item.name}}</div>
                    </div>
                </div>
            </div>




            <div class="input-container">
                <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon" (click)="copyToMain('categories')"
                    *ngIf="stringSelectedCategory != stringSelectedNewCategory" />
                <label for="">Categories</label>
                <div class="cuisine-div" id="categoriesNew">
                    <div *ngFor="let item of allCaategory" style="display: flex; margin-bottom :15px;">
                        <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                            [checked]="preSelectFunc('categoriesNew',item.id)" disabled="true" />
                        <div class="cuisine-name"> {{item.name}}</div>
                    </div>
                </div>
            </div>

            <div class="input-container">
                <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon" (click)="copyToMain('dietPref')"
                    *ngIf="stringSelectedDiet != stringSelectedNewDiet" />
                <label for="">Dietary preference</label>
                <div class="cuisine-div" id="dietPrefNew">
                    <div *ngFor="let item of allDieatary" style="display: flex; margin-bottom :15px;">
                        <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                            [checked]="preSelectFunc('dietPrefNew',item.id)" disabled="true" />
                        <div class="cuisine-name"> {{item.name}}</div>
                    </div>
                </div>
            </div>

            <div class="input-container">
                <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon" (click)="timeCopyFunc()"
                    *ngIf="oldmonOpenHH != monOpenHH || oldmonOpenMM != monOpenMM || oldmonOpenMead != monOpenMead || oldmonPrecheck != monPrecheck || oldmonCloseHH != monCloseHH || oldmonCloseMM != monCloseMM || oldmonCloseMead != monCloseMead || oldtueOpenHH != tueOpenHH || oldtueOpenMM != tueOpenMM || oldtueOpenMead != tueCloseMead ||  oldtueCloseHH != tueCloseHH ||  oldtueCloseMM != tueCloseMM || oldtueCloseMead != tueCloseMead || oldtuePrecheck != tuePrecheck|| oldwedOpenHH != wedOpenHH  ||oldwedOpenMM != wedOpenMM ||oldwedOpenMead != wedOpenMead ||oldwedCloseHH != wedCloseHH ||oldwedCloseMM != wedCloseMM ||oldwedCloseMead != wedCloseMead ||oldwedPrecheck != wedPrecheck ||oldthurOpenHH != thurOpenHH ||oldthurOpenMM != thurOpenMM ||oldthurOpenMead != thurOpenMead ||oldthurCloseHH != thurCloseHH ||oldthurCloseMM != thurCloseMM ||oldthurCloseMead != thurCloseMead ||oldthurPrecheck != thurPrecheck || oldfriOpenHH != friOpenHH ||oldfriOpenMM != friOpenMM||oldfriOpenMead != friOpenMead||oldfriCloseHH != friCloseHH||oldfriCloseMM != friCloseMM||oldfriCloseMead != friCloseMead||oldfriPrecheck != friPrecheck||oldsatOpenHH != satOpenHH||oldsatOpenMM != satOpenMM||oldsatOpenMead != satOpenMead||oldsatCloseHH != satCloseHH||oldsatCloseMM != satCloseMM||oldsatCloseMead != satCloseMead||oldsatPrecheck != satPrecheck||oldsunOpenHH != sunOpenHH||oldsunOpenMM != sunOpenMM||oldsunOpenMead != sunOpenMead||oldsunCloseHH != sunCloseHH||oldsunCloseMM != sunCloseMM||oldsunCloseMead != sunCloseMead||oldsunPrecheck != sunPrecheck" />
                <label for="">Opening and closing hours</label>
                <div class="bigScreen">
                    <div style="margin-left: 15px; display: grid;grid-template-columns: 1fr 1fr 1fr;">
                        <div class="time-text">Select days</div>
                        <div class="time-text">Open timings</div>
                        <div class="time-text">Close timings</div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeNewMon" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('mondayTime',$event.target)" [checked]="monPrecheck"
                                disabled="true">
                            <div class="cuisine-name"> Monday </div>
                        </div>
                        <div id="mondayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="monOpenHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="monOpenMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="monOpenMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="mondayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="monCloseHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="monCloseMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="monCloseMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeNewTue" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('tuesdayTime',$event.target)" [checked]="tuePrecheck" disabled>
                            <div class="cuisine-name"> Tuesday </div>
                        </div>
                        <div id="tuesdayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="tueOpenHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="tueOpenMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="tueOpenMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="tuesdayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="tueCloseHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="tueCloseMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="tueCloseMead" disabled="ture">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>

                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeNewWed" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('wednesTime',$event.target)" [checked]="wedPrecheck" disabled>
                            <div class="cuisine-name"> Wednesday </div>
                        </div>
                        <div id="wednesTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="wedOpenHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="wedOpenMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="wedOpenMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="wednesTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="wedCloseHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="wedCloseMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="wedCloseMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>

                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeNewThu" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('thursdayTime',$event.target)" [checked]="thurPrecheck"
                                disabled>
                            <div class="cuisine-name"> Thursday </div>
                        </div>
                        <div id="thursdayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="thurOpenHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="thurOpenMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="thurOpenMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="thursdayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="thurCloseHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="thurCloseMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="thurCloseMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>

                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeNewFri" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('fridayTime',$event.target)" [checked]="friPrecheck" disabled>
                            <div class="cuisine-name"> Friday </div>
                        </div>
                        <div id="fridayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="friOpenHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="friOpenMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="friOpenMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="fridayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="friCloseHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="friCloseMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="friCloseMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>


                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeNewSat" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('saturdayTime',$event.target)" [checked]="satPrecheck" disabled>
                            <div class="cuisine-name"> Saturday </div>
                        </div>
                        <div id="saturdayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="satOpenHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="satOpenMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="satOpenMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="saturdayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="satCloseHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="satCloseMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="satCloseMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>

                        </div>
                        <div style="display: flex; margin-bottom :15px;">
                            <input type="checkbox" name="" id="timeNewSun" class="largerCheckbox form-check-input"
                                (change)="timeInputFunc('sundayTime',$event.target)" [checked]="sunPrecheck" disabled>
                            <div class="cuisine-name"> Sunday </div>
                        </div>
                        <div id="sundayTimeOpen">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="sunOpenHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="sunOpenMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="sunOpenMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>
                        </div>
                        <div id="sundayTimeClose">
                            <input name="" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 12) this.value = 12; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="HH" [(ngModel)]="sunCloseHH" readonly />
                            <span>:</span>
                            <input name="somename" class="time-input"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength); if(this.value > 59) this.value = 59; if(this.value < 0) this.value = 00;"
                                type="number" maxlength="2" placeholder="MM" [(ngModel)]="sunCloseMM" readonly />
                            <select class="time-selectOption" [(ngModel)]="sunCloseMead" disabled="true">
                                <option value="am" selected>AM</option>
                                <option value="pm">PM</option>
                            </select>

                        </div>

                    </div>

                </div>
            </div>

            <div class="input-container">
                <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon" (click)="copyToMain('specialOffer')"
                    *ngIf="offerOldMonday != offerMonday ||offerOldTuesday != offerTuesday ||offerOldWednesday != offerWednesday ||offerOldTurusday != offerTurusday ||offerOldFriday != offerFriday ||offerOldSaturday != offerSaturday ||offerOldSunday != offerSunday ||offerOldMonValue != offerMonValue ||offerOldTueValue != offerTueValue ||offerOldWedValue != offerWedValue ||offerOldThurValue != offerThurValue ||offerOldFriValue != offerFriValue ||offerOldSatValue != offerSatValue ||offerOldSunValue != offerSunValue" />
                <label for="">Special offers</label>
                <div class="time-text">Select days</div>
                <div style="margin-left: 15px;">
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('mon',$event.target)" [(checked)]="offerMonday"
                                disabled="true">
                            <div class="cuisine-name"> Monday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerMonday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerMonday"
                                [(ngModel)]="offerMonValue" readonly="true">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('tue',$event.target)" [(checked)]="offerTuesday"
                                disabled="true">
                            <div class="cuisine-name"> Tuesday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerTuesday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerTuesday" readonly="true">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('wed',$event.target)" [(checked)]="offerWednesday"
                                disabled="true">
                            <div class="cuisine-name"> Wednesday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerWednesday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerWednesday"
                                [(ngModel)]="offerWedValue" readonly="true">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('thu',$event.target)" [(checked)]="offerTurusday"
                                disabled="true">
                            <div class="cuisine-name"> Thursday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerTurusday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerTurusday"
                                [(ngModel)]="offerThurValue" readonly="true">
                        </div>

                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('fri',$event.target)" [(checked)]="offerFriday"
                                disabled="true">
                            <div class="cuisine-name"> Friday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerFriday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerFriday"
                                [(ngModel)]="offerFriValue" readonly="true">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('sat',$event.target)" [(checked)]="offerSaturday"
                                disabled="true">
                            <div class="cuisine-name"> Saturday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerSaturday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerSaturday"
                                [(ngModel)]="offerSatValue" readonly="true">
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                (change)="offerHandelFunc('sun',$event.target)" [(checked)]="offerSunday"
                                disabled="true">
                            <div class="cuisine-name"> Sunday </div>
                        </div>
                        <div class="offer-sub-div">
                            <!-- <div class="offer-div" *ngIf="offerSunday">Offer Discount (%)</div> -->
                            <input type="text" placeholder="Description of special event/discount" name="" id=""
                                class="form-control" style="width: 100%;" *ngIf="offerSunday"
                                [(ngModel)]="offerSunValue" readonly="true">
                        </div>
                    </div>
                </div>
            </div>

            <div class="input-container">
                <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon" (click)="copyToMain('socialLink')"
                    *ngIf="instagramConNew != instagramCon || instagramValNew != instagramVal ||facebookConNew != facebookCon ||facebookValNew != facebookVal ||googleMapConNew != googleMapCon ||googleMapValNew != googleMapVal" />
                <label for="">Social Links</label>
                <div style="margin-left: 15px;">
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input"
                                [(checked)]="instagramConNew" disabled>
                            <div class="cuisine-name" style="margin-top: 0;"> <img
                                    src="../../../assets/img/Instagram-Logo.wine.svg" alt="" srcset=""
                                    style="max-width: 65px;"> Instagram </div>
                        </div>
                        <div class="offer-sub-div" *ngIf="instagramConNew">
                            <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                                [(ngModel)]="instagramValNew" placeholder="Please give the link" disabled>
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input" disabled
                                [(checked)]="facebookConNew">
                            <div class="cuisine-name" style="margin-top: 0;"> <img
                                    src="../../../assets/img/Facebook-f_Logo-Blue-Logo.wine.svg" alt="" srcset=""
                                    style="max-width: 65px;"> Facebook </div>
                        </div>
                        <div class="offer-sub-div" *ngIf="facebookConNew">
                            <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                                [(ngModel)]="facebookValNew" placeholder="Please give the link" disabled>
                        </div>
                    </div>
                    <div class="offer-main-div">
                        <div class="offer-sub-div">
                            <input type="checkbox" name="" id="" class="largerCheckbox form-check-input" disabled
                                [(checked)]="googleMapConNew">
                            <div class="cuisine-name" style="margin-top: 0;"> <img
                                    src="../../../assets/img/Google_Maps-Icon-Logo.wine.svg" alt="" srcset=""
                                    style="max-width: 65px;"> Google Map </div>
                        </div>
                        <div class="offer-sub-div" *ngIf="googleMapConNew">
                            <input type="url" name="" id="" class="form-control" style="width: 200px; margin: auto 0;"
                                [(ngModel)]="googleMapValNew" placeholder="Please give the link" disabled>
                        </div>
                    </div>
                </div>
            </div>
            <div class="input-container">
                <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon" (click)="copyToMain('logo')"
                    *ngIf="src != NewSrc && NewSrc != '../../../assets/images/Ellipse 11.png'" />
                <label for="restoName">Restaurant Logo</label>
                <div>
                    <span class="imgPreview"><img [src]="NewSrc" alt="" style="border-radius: 50%;" /></span>
                </div>
            </div>

            <div class="input-container">
                <img src="../../../assets/img/leftCopy.png" alt="" class="copyIcon" (click)="copyToMain('featureImg')"
                    *ngIf="featureSrc != newfeatureSrc && newfeatureSrc != '../../../assets/images/Ellipse 11.png'" />
                <label for="restoName">Featured image<span class="starReq">*</span></label>
                <div>
                    <span class="imgPreview"><img [src]="newfeatureSrc" alt="" /></span>

                </div>
            </div>


            <!-- ----------------------------------------------------- -->
        </div>
    </div>
    <div style="display: flex;justify-content:space-between;margin:40px 0 2rem 0;">
        <div class="common submitBtn" (click)="updatedClaimedFunc()"> UPDATE </div>
        <div class="common closeBtn" (click)="closeFunc()"> CLOSE </div>
    </div>
</div>

<!-- --------------------------------------------------------------------------------------------------------------- -->
<style>
    .makeFlex {
        display: flex;

    }

    .bgChange {
        background-color: pink;
    }

    .approve-mainContainer {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    .approve-right-div {
        border-right: 1px dashed black;
        padding-right: 10px;
        margin: 0 10px;
    }

    .approve-left-div {
        margin-right: 10px;
    }

    .copyIcon {
        cursor: pointer;
        width: 23px;
        height: 23px;
        margin: auto 10px auto 0px;
    }

    .cuisine-div {
        display: grid;
        grid-template-columns: 1fr 1fr;
        margin-left: 15px;
    }

    .time-input {
        border: none;
        border-bottom: 1px solid #BCBCBC;
        width: 35px;
        text-align: center;
    }

    .time-input:focus {
        outline: none;
        /* border: none; */
    }

    .time-selectOption {
        border: none;
        background: none;
        width: 50px;
    }

    .time-selectOption:focus {
        outline: none;
    }

    .time-text {
        font-weight: 400;
        font-size: 16px;
        text-decoration: underline;
        margin-bottom: 10px;
        display: block;
    }

    .offer-main-div {
        display: grid;
        grid-template-columns: 1fr 2fr;
    }

    .offer-sub-div {
        display: flex;
        margin-bottom: 15px;
    }

    .offer-div {
        margin: auto 14px auto 0px;
    }

    .menu-img-preview-main {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .pdfMainSpan {
        display: flex;
        max-height: 30px;
        overflow: hidden;
        line-height: 15px;
        cursor: context-menu;
        margin-bottom: 10px;
    }

    .pdfMainSpan img {
        height: 30px;
    }

    .addBtn-mainDiv {
        width: 124px;
        height: 41px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1.5px solid #B6B6B6;
        border-radius: 4px;
        cursor: pointer;
    }

    .addBtn-mainDiv img {
        margin-right: 10px;
    }

    .addBtn-mainDiv span {
        font-weight: 400;
        font-size: 15px;
        line-height: 21px;
        color: #509941;
    }

    .menu-first-div {
        display: flex;
        align-items: center;
    }

    .menu-first-div div:nth-child(2) {
        margin: 0px 15px;
    }

    .common {

        padding: 10px 67px;
        margin: 34px 60px;
        cursor: pointer;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        border-radius: 6px;

    }

    .common:hover {
        box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    }

    .closeBtn {
        color: rgba(57, 64, 70, 1);
        border: 2px solid rgba(57, 64, 70, 1);

    }

    .submitBtn {
        color: rgba(255, 255, 255, 1);
        background: linear-gradient(90.17deg, #2FB9E3 -97.61%, #56AB51 120.65%);
        border-radius: 6px;
    }

    .copyAllBtn {
        position: absolute;
        left: 0;
        z-index: 11;
        font-size: 11px;
        border: 1px solid;
        border-radius: 14px;
        background: transparent;
        line-height: 15px;
    }

    .table-element {
        padding: 0px 3px;
    }
</style>